export class ConsentProviderNotInitializedError extends Error {
    constructor() {
        super('Consent provider not initialized');
        this.name = 'ConsentProviderNotInitializedError';
    }
}